import { useQuery } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { ObjectTagValuesConfigurations } from "../../services/object-tag-values-data-service/ConfigurationModels";
import ObjectTagValuesDataService from "../../services/object-tag-values-data-service/ObjectTagValuesDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseObjectTagValuesConfigurationsQueryParameters = {
    groupID: number;
    objectType: eLynxObjectTypeEnum,
    objectID: number,
} & BaseUseQueryParameters<ObjectTagValuesConfigurations>;

export function useObjectTagValuesConfigurations({
    groupID,
    objectType,
    objectID,
    enabled,
    onError,
    onSuccess
}: UseObjectTagValuesConfigurationsQueryParameters) {
    return useQuery<ObjectTagValuesConfigurations | undefined, RestError>(
        keys.configurationList(
            groupID,
            objectType,
            objectID
        ),
        ({ signal }) => {
            return ObjectTagValuesDataService.getConfigurations(
                groupID,
                objectType,
                objectID,
                signal
            );
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}